import { GatsbyImage, getImage } from "gatsby-plugin-image";
import React from "react";
import SectionWrapper from "../SectionWrapper";

interface Props {
  primaryPhoto: Queries.EventPageQuery["datoCmsEvent"]["primaryPhoto"];
}

const EventPageSectionPrimaryPhoto = ({ primaryPhoto }: Props) => {
  const image = getImage(primaryPhoto);
  return (
    <SectionWrapper noBorder additionalWrapperClassName="lg:mt-16">
      <GatsbyImage image={image} alt={primaryPhoto.alt} />
    </SectionWrapper>
  );
};

export default EventPageSectionPrimaryPhoto;
